import React, { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';

// Location create/edit form used inside the client detail dialog.
export const LocationForm = ({ location, onSave, onCancel }) => {
  const [form, setForm] = useState({
    id: location?.id || null,
    name: location?.name || '',
    address: location?.address || '',
    city: location?.city || '',
    state: location?.state || '',
    zip_code: location?.zip_code || '',
    delivery_instructions: location?.delivery_instructions || '',
    receiving_hours: location?.receiving_hours || '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(form);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <Label>Location Name</Label>
        <Input
          value={form.name}
          onChange={(e) => setForm(prev => ({ ...prev, name: e.target.value }))}
          placeholder="Main Store"
          required
        />
      </div>
      <div>
        <Label>Street Address</Label>
        <Input
          value={form.address}
          onChange={(e) => setForm(prev => ({ ...prev, address: e.target.value }))}
          placeholder="123 Main St"
          required
        />
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div>
          <Label>City</Label>
          <Input
            value={form.city}
            onChange={(e) => setForm(prev => ({ ...prev, city: e.target.value }))}
            required
          />
        </div>
        <div>
          <Label>State</Label>
          <Input
            value={form.state}
            onChange={(e) => setForm(prev => ({ ...prev, state: e.target.value }))}
            required
          />
        </div>
        <div>
          <Label>ZIP</Label>
          <Input
            value={form.zip_code}
            onChange={(e) => setForm(prev => ({ ...prev, zip_code: e.target.value }))}
            required
          />
        </div>
      </div>
      <div>
        <Label>Receiving Hours</Label>
        <Input
          value={form.receiving_hours}
          onChange={(e) => setForm(prev => ({ ...prev, receiving_hours: e.target.value }))}
          placeholder="Mon-Fri 6am-2pm"
        />
      </div>
      <div>
        <Label>Delivery Instructions</Label>
        <Textarea
          value={form.delivery_instructions}
          onChange={(e) => setForm(prev => ({ ...prev, delivery_instructions: e.target.value }))}
          placeholder="Enter through back door, ask for manager"
          rows={2}
        />
      </div>
      <div className="flex justify-end gap-2 pt-4">
        <Button type="button" variant="outline" onClick={onCancel}>Cancel</Button>
        <Button type="submit" className="bg-amber-500 hover:bg-amber-600">
          {form.id ? 'Update' : 'Add'} Location
        </Button>
      </div>
    </form>
  );
};
